import React, { useEffect, useState, useRef } from 'react';
import './ideas_busq.css'
import { useTranslation } from 'react-i18next';
import Modal from "../../../components/modal2026/Modal";
import ModalVideo from "../../../components/modal2026/ModalVideo.jsx";

const Ideas_busq = ({ contenidoideas }) => {
    const [t, i18n] = useTranslation("ideaCorta");

    const renderizarMensaje = (tipo, contenido, preview, index, id, titulo) => {
        if (tipo === "texto") {
            return (
                <>
                    <div className="_ngcontent-ng-c485834739 _nghost-ng-c1461349688">
                        <article class="reflexion-video-card reflexion-video-card--text" onClick={() => openModal(contenido, "texto", "", id, titulo)}>
                            <div class="reflexion-video-card__text-surface">
                                <p class="reflexion-video-card__excerpt" dangerouslySetInnerHTML={{ __html: contenido }}></p>
                                <p class="reflexion-video-card__continue">
                                    <span>Continuar leyendo</span>
                                </p>
                                <p class="reflexion-video-card__duration">
                                </p>
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "imagen") {
            return (
                <>
                    <div className="card-type-img" onClick={() => openModal("https://www.ricardosalinas.com" + preview, "imagen", preview, id, "")}>
                        <img
                            className="img1"
                            src={"https://www.ricardosalinas.com" + preview}
                            alt="Imagen ideas"
                        />
                    </div>
                </>
            );
        } else if (tipo === "texto-video") {
            return (
                <>
                    <div>
                        <article onClick={() => openModal(contenido, "", preview, id, titulo)} class="reflexion-video-card"><img
                            loading="lazy" class="reflexion-video-card__image"
                            src={"https://www.ricardosalinas.com" + preview}
                            alt="titulo" /><button type="button" class="reflexion-video-card__play-button"
                                aria-label="Reproducir En México existe una compra masiva del voto"><img
                                    src="/assets/img2026/video_player_button.svg" alt="titulo"
                                    aria-hidden="true" /></button>
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}</h2>
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "texto-imagen") {

            return (
                <>
                    <div>
                        <article class="reflexion-video-card reflexion-video-card--story-image"
                            onClick={() => openModal(contenido, "texto-imagen", preview, id, titulo)}>
                            <img loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview} alt={titulo} />
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}
                                </h2>
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "carrete") {
            return (
                <>
                    <div>
                        <article class="reflexion-video-card reflexion-video-card--story-image"
                            onClick={() => openModal(contenido, "carrete", preview, id, titulo)}>
                            <img loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview} alt={titulo} />
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}
                                </h2>
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "youtube") {
            return (
                <>
                    <div>
                        <article onClick={() => openModalVideo(contenido, id)}
                            class="reflexion-video-card"><img
                                loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview}
                                alt={"Reproducir "+titulo} /><button type="button" class="reflexion-video-card__play-button"
                                    aria-label="Reproducir En México existe una compra masiva del voto"><img
                                    src="/assets/img2026/video_player_button.svg" alt={"reproducir"+titulo}
                                    aria-hidden="true" /></button>
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}</h2>
                            </div>
                        </article>
                    </div>
                </>
            );
        } else if (tipo === "video") {
            return (
                <>
                    <div>
                        <article onClick={() => openModal("https://www.ricardosalinas.com" + contenido, "video", preview, id, titulo)}
                            class="reflexion-video-card"><img
                                loading="lazy" class="reflexion-video-card__image"
                                src={"https://www.ricardosalinas.com" + preview}
                                alt={"reproducir"+titulo} /><button type="button" class="reflexion-video-card__play-button"
                                    aria-label="Reproducir En México existe una compra masiva del voto"><img
                                    src="/assets/img2026/video_player_button.svg" alt={"reproducir"+titulo}
                                    aria-hidden="true" /></button>
                            <div class="reflexion-video-card__copy">
                                <h2 class="reflexion-video-card__title">{titulo}</h2>
                            </div>
                        </article>
                    </div>

                </>
            );
        } else {
            return <p>La condición es falsa que tipo eres-----: {tipo}</p>;
        }

    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [id_liga, setId_liga] = useState("");
    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");
    const [variable3, setVariable3] = useState("");

    const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
    const [urlVideo, setUrlVideo] = useState("");
    const [idVideo, setidVideo] = useState("");

    const openModal = (value1, value2, value3, value4, value5) => {
        setVariable1(value1);
        setVariable2(value2);
        setVariable3(value5);
        setId_liga(value4);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setVariable1("");
        setVariable2("");
        setVariable3("");
        setIsModalOpen(false);
    };

    const openModalVideo = (contenido, value4) => {
        setUrlVideo(contenido);
        setIsOpenModalVideo(true);
        setidVideo(value4);
    };

    const closeModalVideo = () => {
        setUrlVideo("");
        setIsOpenModalVideo(false);
        setidVideo("");
    };

    const IdeasSkeleton = () => (
        <div className="reflexion-video-card reflexion-video-card--skeleton">
            <div className="skeleton-box reflexion-video-card__image" />
            <div className="reflexion-video-card__copy">
                <div className="skeleton-line w-60" />
                <div className="skeleton-line w-80" />
            </div>
        </div>
    );

    if (!contenidoideas || !contenidoideas.ideas || contenidoideas.ideas.length === 0) {
        // Handle the case where `contenido` or `blogNs` is not available or is an empty array.
        return <div></div>;
    }

    return (
        <>
            <h2 _ngcontent-ng-c2327341559="" class="busqueda-page__section-title">Ideas</h2>
            <div className="_ngcontent-ng-c2574764019">
                <section _ngcontent-ng-c485834739="" aria-label="Videos de reflexión" class="reflexiones-videos">

                    {contenidoideas.ideas.length === 0 ? (
                        Array.from({ length: 8 }).map((_, i) => (
                            <IdeasSkeleton key={i} />
                        ))
                    ) : (
                        contenidoideas.ideas.map((item, index) => (
                            <React.Fragment key={item.id || index}>
                                {renderizarMensaje(
                                    item.tipo,
                                    item.contenido,
                                    item.preview,
                                    index,
                                    item.id,
                                    item.titulo
                                )}
                            </React.Fragment>
                        ))
                    )
                    }
                </section>
                <Modal
                    isOpen={isModalOpen}
                    closeModal={closeModal}
                    variable1={variable1}
                    variable2={variable2}
                    variable3={variable3}
                    id_idea={id_liga}
                />

                <ModalVideo
                    isOpen={isOpenModalVideo}
                    closeModal={closeModalVideo}
                    urlVideo={urlVideo}
                    id_idea={idVideo}
                />
            </div>
        </>
    );

}

export default Ideas_busq;